import axiosInstance from '../utils/axios';
import { mergeDashboardConfig, getDashboardConfigCacheKey } from '../utils/dashboardConfigUtils';
import { getCurrentUser } from './authService';

const getCompanyId = () => {
  const user = getCurrentUser();
  return user?.companyId ?? user?.company?.id ?? null;
};

export const getDashboardConfig = async ({ useCache = true } = {}) => {
  const companyId = getCompanyId();
  const cacheKey = getDashboardConfigCacheKey(companyId);

  if (useCache && companyId) {
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        return mergeDashboardConfig(JSON.parse(cached));
      }
    } catch {
      /* ignore */
    }
  }

  const res = await axiosInstance.get('/companies/settings/dashboard');
  const config = mergeDashboardConfig(res.data?.config);
  if (companyId) {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(config));
    } catch {
      /* ignore */
    }
  }
  return config;
};

export const saveDashboardConfig = async (config) => {
  const res = await axiosInstance.put('/companies/settings/dashboard', { config });
  const saved = mergeDashboardConfig(res.data?.config || config);
  const companyId = getCompanyId();
  if (companyId) {
    try {
      sessionStorage.setItem(getDashboardConfigCacheKey(companyId), JSON.stringify(saved));
    } catch {
      /* ignore */
    }
  }
  return saved;
};

export const clearDashboardConfigCache = () => {
  const companyId = getCompanyId();
  if (companyId) {
    sessionStorage.removeItem(getDashboardConfigCacheKey(companyId));
  }
};

export default {
  getDashboardConfig,
  saveDashboardConfig,
  clearDashboardConfigCache,
};
